import {useEffect} from 'react'

export const useHomeScrollAnimation = () => {
    useEffect(() => {
        const sections = ['about', 'how-it-works', 'pricing', 'faq']
        const headerLinkAbout = document.getElementById("header-link-about")
        const headerLinkPricing = document.getElementById("header-link-pricing")
        const headerLinkFaq = document.getElementById("header-link-faq")

        const options = {
            root: null,
            rootMargin: "0px",
            threshold: 0.2
        }
        const targetSections = document.querySelectorAll("section")

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const entryId = entry.target.getAttribute("id")
                    if (!entryId) return
                    if (sections.includes(entryId)) {
                        entry.target.setAttribute("data-state", "active")
                    }
                    if (entryId === 'about' || entryId === 'how-it-works') {
                        headerLinkAbout.classList.add("active")
                        headerLinkPricing.classList.remove("active")
                        headerLinkFaq.classList.remove("active")
                    } else if (entryId === 'pricing') {
                        headerLinkAbout.classList.remove("active")
                        headerLinkPricing.classList.add("active")
                        headerLinkFaq.classList.remove("active")
                    } else if (entryId === 'faq' || entryId === 'cta-banner') {
                        headerLinkAbout.classList.remove("active")
                        headerLinkPricing.classList.remove("active")
                        headerLinkFaq.classList.add("active")
                    } else {
                        headerLinkAbout.classList.remove("active")
                        headerLinkPricing.classList.remove("active")
                        headerLinkFaq.classList.remove("active")
                    }
                }
            })
        }, options)

        targetSections.forEach((section) => {
            observer.observe(section)
        })

        return () => {
            headerLinkAbout.classList.remove("active")
            headerLinkPricing.classList.remove("active")
            headerLinkFaq.classList.remove("active")
            observer.disconnect()
        };
    }, [])
}